import React from 'react';
import {Redirect, Route} from 'react-router-dom';

import {AdminContainer} from './components/admin';
import {DashboardPage} from './components/dashboard';
import {LoginPage} from './components/login';
import {SplashPage} from './components/splash';

import {ROLE_TYPES} from './constants/roleTypes';

const Routes = ({profile}) => {
    const defaultAdminTabPath = profile.role ? (profile.isAdmin ? '/users' : '/events') : '';
    const defaultAdminPagePath = !profile.isEmpty ? `/admin/${profile.isAdmin ? ROLE_TYPES.ADMIN.key : profile.role[0]}${defaultAdminTabPath}` : '';
    return (
        <div className="container">
            <Route exact path="/" component={SplashPage} />

            <Route path={["/dashboard/spoc/:officeId", "/dashboard/:officeId"]} component={DashboardPage}/>

            <Route path="/admin" exact render={() => !profile.isEmpty ? <Redirect to={defaultAdminPagePath}/> : <Redirect to={"/login"}/>}/>
            <Route path="/admin/:page/:tab" render={(props) => !profile.isEmpty ? <AdminContainer profile={profile} {...props}/> : <Redirect to={"/login"}/>}/>

            <Route exact path="/login" render={() => {
                return profile.isEmpty ? <Route component={LoginPage}/> : <Redirect to="/admin"/>;
            }}/>
        </div>
    );
};

export default Routes;


// WEBPACK FOOTER //
// ./src/Routes.js